// Deriva as variacoes (rgb, clara, escura) da cor de destaque escolhida pela corretora e aplica
// como CSS custom properties no <html> — index.css e todo inline style que usa var(--primary...)
// passam a refletir a cor customizada sem precisar recarregar a pagina.
function hexParaRgb(hex) {
  const limpo = (hex || '').replace('#', '')
  const n = parseInt(limpo.length === 3 ? limpo.split('').map(c => c + c).join('') : limpo, 16)
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

function misturar(rgb, alvo, peso) {
  return {
    r: Math.round(rgb.r + (alvo.r - rgb.r) * peso),
    g: Math.round(rgb.g + (alvo.g - rgb.g) * peso),
    b: Math.round(rgb.b + (alvo.b - rgb.b) * peso),
  }
}

const paraHex = ({ r, g, b }) => '#' + [r, g, b].map(v => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('')

// Usados por templates que renderizam fora do documento principal (relatorios em PDF/impressao
// abertos em janela nova) e por canvas — nao herdam as CSS custom properties do <html>, entao
// precisam do hex ja resolvido em vez de var(--primary...).
export const corClara = (hex) => paraHex(misturar(hexParaRgb(hex), { r: 255, g: 255, b: 255 }, 0.92))
export const corEscura = (hex) => paraHex(misturar(hexParaRgb(hex), { r: 0, g: 0, b: 0 }, 0.18))

export function aplicarCorPrimaria(hex) {
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) return
  const rgb = hexParaRgb(hex)
  const root = document.documentElement.style
  root.setProperty('--primary', hex)
  root.setProperty('--primary-rgb', `${rgb.r},${rgb.g},${rgb.b}`)
  root.setProperty('--primary-light', corClara(hex))
  root.setProperty('--primary-dark', corEscura(hex))
}
